import CamposTorneoEtapa from '../campos/CamposTorneoEtapa.js';
import TablaTorneoEtapas from '../tablas/TablaTorneoEtapas.js';
import * as Campos from '../../constantes/Campos.js';

// Funciones para CuadroEditableLista

export const armarFilasTabla = (lista, idElegido, onEditarItem, onEliminarItem) => {
  return (
    <TablaTorneoEtapas
      lista={lista}
      idElegido={idElegido}
      onEditarItem={onEditarItem}
      onEliminarItem={onEliminarItem}
    />
  );
};

export const OrdenarLista = (itemA, itemB) => {
  // Ordenar por orden ascendente
  const ordenA = itemA.orden || 0;
  const ordenB = itemB.orden || 0;
  return ordenA - ordenB;
};

// Funciones para EditarItemLista

export const CamposEdicion = (idPadre, item, editar, actualizar, onCampoChange) => {
  return (
    <CamposTorneoEtapa
      idPadre={idPadre}
      item={item}
      editar={editar}
      actualizar={actualizar}
      onCampoChange={onCampoChange}
    />
  );
};

export const OnCampoChange = (item, campo, valor) => {
  switch (campo) {
    case Campos.TorneoEtapa.ORDEN: {
      return { ...item, orden: valor };
    }
    case Campos.TorneoEtapa.ETAPA: {
      return { ...item, etapa: valor };
    }
    case Campos.TorneoEtapa.DEFINICION: {
      // Cuando cambia el tipo de etapa, resetear cantidadFechas si es definición
      const nuevaCantidadFechas = valor === true ? null : item.cantidadFechas;
      return { ...item, definicion: valor, cantidadFechas: nuevaCantidadFechas };
    }
    case Campos.TorneoEtapa.CANTIDAD_RUEDAS: {
      return { ...item, cantidadRuedas: valor };
    }
    case Campos.TorneoEtapa.CANTIDAD_CRUCES: {
      return { ...item, cantidadCruces: valor };
    }
    case Campos.TorneoEtapa.CANTIDAD_FECHAS: {
      return { ...item, cantidadFechas: valor };
    }
    case Campos.TorneoEtapa.ZONAS: {
      return { ...item, zonas: valor };
    }
    default: {
      throw new Error('Campo ' + campo + ' no definido');
    }
  }
};

export const ValidarItemGrabar = (item) => {
  let error = '';
  if (!item) {
    error = 'No se informaron datos para la etapa';
  } else if (!item.orden || item.orden <= 0) {
    error = 'Debe indicar el orden de la etapa (número positivo)';
  } else if (!item.etapa) {
    error = 'Debe seleccionar el tipo de etapa';
  } else if (item.definicion === null || item.definicion === undefined) {
    error = 'Debe indicar si la etapa es de grupos o de definición';
  } else if (!item.cantidadRuedas || item.cantidadRuedas <= 0 || item.cantidadRuedas > 9) {
    error = 'La cantidad de ruedas es obligatoria (1-9)';
  } else if (!item.cantidadCruces || item.cantidadCruces <= 0 || item.cantidadCruces >= 100) {
    error = 'La cantidad de cruces es obligatoria (número positivo menor a 100)';
  } else if (!item.definicion) {
    // Etapa de grupos - zonas es obligatorio
    if (item.zonas === null || item.zonas === undefined) {
      error = 'Para etapas de grupos, debe indicar si la etapa tiene zonas';
    } else if (
      item.cantidadFechas !== null &&
      item.cantidadFechas !== undefined &&
      (item.cantidadFechas <= 0 || item.cantidadFechas >= 100)
    ) {
      error = 'La cantidad de fechas debe ser un número positivo menor a 100';
    }
  }
  return error;
};
